export const APIendpoints = {
  // Bidding APIs
  getBiddingSessionTypes: `/public/api/bidding/bidding_session_types`,
  getBiddingSessions: `/public/api/bidding/get_bidding_sessions`,
  getBiddingSession: `/public/api/bidding/get_bidding_session`,
  getBids: `/public/api/bidding/get_bids`,
  upsertBids: `/public/api/bidding/upsert_bids`,
  submitBids: `/public/api/bidding/submit_bids`,
  registerBiddingParticipant: `/public/api/bidding/register_participant`,
  getAllotment: `/public/api/bidding/get_allotment`,
  getEstimatedAllotment: `/public/api/bidding/get_estimated_allotment`,
  getBiddingSessionCounts: `/public/api/bidding/get_bidding_session_counts`,
  getBiddingTerms: `/public/api/bidding/get_bidding_terms`,
  getBiddingHomePage: `/public/api/bidding/home_page`,
  //Po-Grn Related APIs
  sendOtp: `/public/api/seller/getOtp`,
  validateOtp: `/public/api/seller/validateOtp`,
  getSignupOtp: `/public/api/seller/getSignupOtp`,
  onboardSeller: `/public/api/seller/onboard_seller`,
  getSellerOnboarding: `/public/api/seller_hub/get_seller_onboarding_request`,
  upsertSellerOnboarding: `/public/api/seller_hub/upsert_seller_onboarding_request`,
  verifyBankDetails: `/public/api/seller_hub/v2/verifyBankDetails`,
  onboardSelfOnboardingSeller: `/public/api/seller_hub/onboard_self_onboarding_seller`,
  getPurchaseOrderList: `public/api/seller_hub/wms/purchase_order_list`,
  getPoGrnMappings: `public/api/seller_hub/wms/po-grn-mappings`,
  updateSellerStatus: `public/api/seller_hub/wms/update_seller_status`,
  getSellerDetails: `public/api/seller_hub/wms/get_seller_details`,
  getSellerProfile: `public/api/seller_hub/get_seller_profile`,
  updatePurchaseOrder: `/public/api/seller_hub/purchase_order`,
  getPresignedUrl: `/api/seller/create_presigned_url`,
  validatePodOtp: `/api/seller/validate_otp`,
  validatePodImage: `/api/seller/validate_image`,
  uploadPodImage: `/api/seller/pod`,
  sellerOrderDetails: (orderId) => `api/seller/orders/${orderId}`,
  createAndGetCnData: `public/api/seller_hub/create_and_get_cn_data`,
  markBuyerOrderCompletedLinkedToDDPurchaseOrder: `/public/api/seller_hub/complete_buyer_order`,
  getBuyerOrderPodDetails: `public/api/seller_hub/wms/buyer_order_pod_details`,
  markBulkBuyerOrderCompletedLinkedToMandiDDPurchaseOrder:
    "/public/api/seller_hub/wms/bulk_complete_buyer_orders",
  generateEwb: "/public/api/seller_hub/wms/generate_ewb",
  uploadSupportingDocuments: "/public/api/seller_hub/wms/upload_po_supporting_documents",
  grnDocumentUpdateData: `/public/api/seller_hub/grn_document_update`,
  homePagePopUp: `/public/api/seller_hub/wms/home_page_popup`,
  homePageSections: `/public/api/seller_hub/wms/home_page_sections`,
  getGrnPaymentOptions: `/public/api/seller-hub/grn-payment-options`,
  getAccessToken: `/public/api/seller_hub/payment/accesstoken`,
  getPaymentHash: `/public/api/seller_hub/payment/paymenthash`,
  //forGeneric APIs
  uploadDocument: `/public/api/seller_hub/document`,
  sellerHubHomePage: "/public/api/seller/logout/landing-details",
  sellerOnboarding: "/public/api/seller_hub/seller_onboarding_request",
  sellerCategories: "/public/api/seller_hub/categories",
  fetchAppConfigs: "/public/api/sellerapp/appVersionCheck",
  generateInvoiceDoc: `/public/api/seller_hub/generate_invoice`,
  searchServicePurchaseOrders: `/public/api/seller_hub/search/service_purchase_orders`,
  processServiceDoc: `/public/api/seller_hub/services/process/doc`,
  downloadMIS: `/public/api/seller_hub/mis/download`,
  downloadPendingPayments: `/public/api/seller_hub/pending_payments/download`,
  getAllCities: '/public/api/seller_hub/wms/city',
  sendSellerAppTracking: '/public/api/sellerapp/tracking',
  signout: '/public/api/signout',
  deleteAccount: '/public/api/seller/delete_account',
  generateEmbeddedUpc: `/public/api/seller_hub/embedded-upc/generate`,
  getVendorProductsFromPO: `/public/api/seller_hub/wms/vendor_products_from_po`,
  getVendorProducts: `/public/api/seller_hub/wms/vendor_products`,
  sellerOutletToUserMapping: `/public/api/seller/seller_outlet_to_user_mapping`,
  createSellerOutletToUserMapping: `/public/api/seller/seller_outlet_to_user_mapping`,
  getUsersByContact: `/public/api/seller_hub/get_users_by_contact`,
  getVendorTransactions: `/public/api/seller_hub/vendor-transactions`,
  getVendorAccruals: `/public/api/seller_hub/vendor-accruals`,
};

export const DefaultParams = {
  getPurchaseOrder: {
    purchase_order_id: "",
    purchase_order_number: "",
    vendor_id: "",
    page_size: 20,
    page_no: 1,
    warehouse_code: "",
    created_at: "",
    expected_delivery_date: "",
    po_status: "",
    grn_number: "",
    is_item_required: false,
    is_payment_details_required: "",
    is_history_required: "",
    payment_status: "",
    payment_number: "",
    po_consideration_dt: "",
    outlet_name: "",
    created_at_dt_rng: "",
    vendor_account_id: "",
    po_amt_range: "",
    order_tag: "",
    invoice_mismatch: "",
    is_organization_details_required: false,
    created_by_user_ids: [],
    is_po_grn_items_required: false,
    is_po_grn_mapping_required: false,
    seller_status: "",
    fetch_po_with_no_grns: false,
    fetch_invoice: false,
    fetch_po_with_no_seller_invoice: false,
    is_delivery_details_required: false,
    seller_action_status: "",
    order_status: "",
    order_tags: "",
    filter_direct_delivery_by_order_ref: false,
    fetch_active_product_variants: false,
    fetch_count_only: false,
    skip_product_number_quality_checking_status: true,
  },

  getPoGrnMappings: {
    purchase_order_id: 0,
    purchase_order_number: "",
    warehouse_code: "",
    po_grn_mapping_id: 0,
    page_number: 1,
    page_size: 20,
    is_po_grn_items_required: false,
    grn_status: "",
    grn_statuses: [],
    warehouse_codes: "",
    payment_status: "",
    outlet_name: "",
    outlet_id: 0,
    account_id: 0,
    is_invoice_generation_disabled: false,
    tnc_accepted: false,
    seller_status: "",
    is_payment_details_required: false,
    is_seller_status_history_required: false,
    get_cn_data: false,
    get_prn_data: false,
    exclude_purchase_order_tags: "",
    fetch_only_partial_count_till: 0,
    fetch_only_count: false,
  },

  updateSellerStatus: {
    entity_id: 0,
    entity_type: "",
    seller_status: "",
    supplier_bill: "",
    account_id: 0,
    tnc_accepted_time: "",
    supplier_bill_number: "",
    grn_payment_type: "",
    discount_percentage: 0,
  },

  getSellerDetails: {
    phone_number: "",
    check_for_dn_tncs: false,
  },

  updateSellerInvoice: {
    invoice_number: "",
    invoice_date: "",
    invoice_amount: 0,
    order_bill_image: "",
    dd_order_details: "",
    pod_order_id: 0,
    number_of_pod_pages: 0,
    order_id: 0,
    page_number: 0,
    file_path: "",
  },

  getBuyerOrderPodDetails: {
    purchase_order_id: 0,
  },

  getGrnDocumentUpdateData: {
    grn_number: "",
    reference_number: "",
    get_presigned_url: false,
    source: "",
  },

  updateGrnDocumentUpdateData: {
    reference_number: "",
    grn_number: "",
    invoice_number: "",
    invoice_amount: 0,
    document_path: "",
    status: "",
  },

  getHomePagePopUpParams: {
    seller_outlet_id: "",
  },

  getHomePageSectionsParams: {
    seller_outlet_id: "",
  },

  fetchAppConfigs: {
    app_mode: "",
  },
};
